import { render, staticRenderFns } from "./EditDrinkDialog.vue?vue&type=template&id=5563489c&scoped=true&lang=pug"
import script from "./EditDrinkDialog.vue?vue&type=script&lang=js"
export * from "./EditDrinkDialog.vue?vue&type=script&lang=js"
import style0 from "./EditDrinkDialog.vue?vue&type=style&index=0&id=5563489c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5563489c",
  null
  
)

export default component.exports